import { Dispatch } from 'redux';
import Attachments from "../../services/Attachments";
import { createRestSlices, applyReducers, Callback } from './rest';
import { ActionPayload } from '..';
import Attachment from "../../models/Attachment";
import { attachmentMatchesListFilters, removeFromList, upsertList } from './remoteUpdate';

const {
    initialState: restInitialState,
    createReducer, startCreateReducer,
    getReducer, listReducer,
    updateReducer, deleteReducer,
    createAction, startCreateAction,
    getAction, listAction,
    updateAction, deleteAction,
} = createRestSlices(Attachments);

const initialState = {
    ...restInitialState,
    /** Filters of the last `loadAttachments` call — scopes Mercure inserts. */
    listFilters: null as AnyObj | null,
};

const SET_LIST_FILTERS = 'yoda/attachments/SET_LIST_FILTERS';

const listFiltersReducer = (state = initialState, action: ActionPayload) => {
    if (action.type !== SET_LIST_FILTERS)
        return state;
    return {
        ...state,
        listFilters: action.filters || {},
    };
};

const UPDATE = 'yoda/mercure/REMOTE_UPDATE';
const onRemoteUpdateReducer = (state = initialState, action: ActionPayload) => {
    if (action.type !== UPDATE)
        return state;

    const { update: { data, type }} = action;
    switch (type) {
        case 'attachment.created':
            // Topic `*` delivers every project's intake uploads; only keep those
            // that match the attachments list currently on screen.
            if (!attachmentMatchesListFilters(data, state.listFilters))
                return state;
            return {
                ...state,
                attachments: upsertList(state.attachments, data, (payload) => new Attachment(payload), true)
            };
        case 'attachment.deleted':
            return {
                ...state,
                attachments: removeFromList(state.attachments, data._id)
            };
        default:
            return state;
    }
};

/* Export reducer */
/* eslint import/no-anonymous-default-export: [2, {"allowArrowFunction": true}] */
export default (state = initialState, action: ActionPayload) => {
    return applyReducers(state, action, [
        listFiltersReducer,
        createReducer, startCreateReducer,
        getReducer, listReducer,
        updateReducer, deleteReducer,
        onRemoteUpdateReducer
    ]);
}

const CREATING_ATTTACHMENT_SUCCESS = `yoda/attachment/CREATING_ITEM_SUCCESS`;
export const addedAttachment = (attachment: Attachment) => {
    return (dispatch: Dispatch) => {
        dispatch({type: CREATING_ATTTACHMENT_SUCCESS, attachment});
    }
};
const DELETING_ATTTACHMENT_SUCCESS = `yoda/attachment/DELETING_ITEM_SUCCESS`;
export const deletedAttachment = (attachment: Attachment) => {
    return (dispatch: Dispatch) => {
        dispatch({type: DELETING_ATTTACHMENT_SUCCESS, attachment});
    }
};

/* Export CRUD actions */
export const createAttachment      = createAction;
export const startCreateAttachment = startCreateAction;
export const loadAttachment        = getAction;
export const loadAttachments       = (filters?: AnyObj, callback?: Callback) => {
    return (dispatch: Dispatch) => {
        dispatch({ type: SET_LIST_FILTERS, filters: filters || {} });
        return listAction(filters, callback)(dispatch);
    };
};
export const updateAttachment      = updateAction;
export const deleteAttachment      = deleteAction;
